import React from 'react';
import { PlusIcon } from 'lucide-react';
export const TeamMembers = () => {
  // Sample team members data
  const members = [{
    id: 1,
    name: 'John Doe',
    initials: 'JD',
    color: 'bg-blue-500',
    online: true
  }, {
    id: 2,
    name: 'Emma Thompson',
    initials: 'ET',
    color: 'bg-green-500',
    online: true
  }, {
    id: 3,
    name: 'Michael Chen',
    initials: 'MC',
    color: 'bg-purple-500',
    online: false
  }, {
    id: 4,
    name: 'Sarah Johnson',
    initials: 'SJ',
    color: 'bg-yellow-500',
    online: true
  }, {
    id: 5,
    name: 'David Wilson',
    initials: 'DW',
    color: 'bg-pink-500',
    online: false
  }];
  return <div className="flex -space-x-2" data-id="element-106">
      {members.map((member, index) => <div key={member.id} className={`w-8 h-8 rounded-full ${member.color} flex items-center justify-center text-white font-medium text-xs border-2 border-white relative`} title={member.name} data-id="element-107">
          {member.initials}
          {member.online && <span className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-green-400 border-2 border-white rounded-full" data-id="element-108"></span>}
        </div>)}
      <button className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center border-2 border-white" data-id="element-109">
        <PlusIcon size={14} className="text-gray-600" data-id="element-110" />
      </button>
    </div>;
};